"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLoanProductShell = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const createLoanProductShell = ({ loanProductId, orgSlug, }) => ({
    _id_: loanProductId,
    eligibilityTests: [],
    concentrationLimits: [],
    receivableValuationRate: {
        type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.ReceivableValuationRateProperty,
        name: 'Receivable Valuation Rate',
        description: '',
        value: 'Placeholder',
        section: '',
        _isWrittenIn_: true,
        _config_: {
            receivableValuationRateConfig: {
                type: 'formula',
                config: {
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"TODO"',
                },
            },
        },
    },
    receivableAdvanceRate: {
        type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.ReceivableAdvanceRateProperty,
        name: 'Receivable Advance Rate',
        description: '',
        value: 'Placeholder',
        section: '',
        _isWrittenIn_: true,
        _config_: {
            receivableAdvanceRateConfig: {
                type: 'formula',
                config: {
                    engineVersion: finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1,
                    formula: '"TODO"',
                },
                loanProductIds: [loanProductId],
            },
        },
    },
    _config_: {
        externalReceivableIdField: '<Placeholder Fieldname>',
        baseFieldConfigs: [],
        intermediateCalcConfigs: [
            {
                field: 'assignmentExclusion',
                fieldType: 'string',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"TODO"',
                },
            },
            {
                field: 'exposure',
                fieldType: 'float',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"TODO"',
                },
            },
            {
                field: 'originalOwnerSlug',
                fieldType: 'string',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: `"${orgSlug}"`,
                },
            },
            {
                field: 'waiveAllEligibility',
                fieldType: 'boolean',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: 'FALSE',
                },
            },
            {
                field: 'waiveAllConcentration',
                fieldType: 'boolean',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: 'FALSE',
                },
            },
            {
                field: 'includeInConcentrationLimitDenominatorIfWaived',
                fieldType: 'boolean',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: 'FALSE',
                },
            },
            {
                field: 'normalizedDurationDays',
                fieldType: 'optionalFloat',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
            {
                field: 'normalizedisChargedOff',
                fieldType: 'optionalBoolean',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
            {
                field: 'normalizedisDelinquent',
                fieldType: 'optionalBoolean',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
            {
                field: 'normalizedDaysPastDue',
                fieldType: 'optionalFloat',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
            {
                field: 'normalizedOriginationDate',
                fieldType: 'optionalDate',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
            {
                field: 'normalizedInitialBalance',
                fieldType: 'optionalFloat',
                config: {
                    type: 'formula',
                    engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                    formula: '"jsNull"',
                },
            },
        ],
        vintageCurveFormulaDenominator: 'exposure',
    },
});
exports.createLoanProductShell = createLoanProductShell;
//# sourceMappingURL=createLoanProductShell.js.map